export default __webpack_public_path__ + "static/media/RainbookLoading.ba0e6127.gif";